import { FormType } from '../../../form-types';
import { WeightLossFieldAnswers } from '../questions';

export const wlus: FormType<WeightLossFieldAnswers> = {
  name: 'Weight Loss',
  olderVersions: ['wlus_032025', 'wlus_2024', 'wlus_archived'],
  questions: [
    {
      key: 'wlus_genderIdentify',
      next: {
        condition: {
          'wlus_genderIdentify.wlus_genderIdentify_male': true
        },
        key: 'wlus_highestWeight',
        els: 'wlus_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlus_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlus_pregnantOrBreastfeedingOrPlanningTo.wlus_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_consentPregnancy'
      }
    },
    {
      key: 'wlus_consentPregnancy',
      next: {
        condition: {
          'wlus_consentPregnancy.wlus_consentPregnancy_non_consent': true
        },
        key: 'wlus_didNotConsent',
        els: 'wlus_highestWeight'
      }
    },
    'wlus_highestWeight',
    'wlus_weightAndHeight2025',
    {
      key: 'wlus_consentBmi',
      next: {
        condition: {
          'wlus_consentBmi.wlus_consentBmi_consent': true
        },
        key: 'wlus_diagnoseTimeline',
        els: 'wlus_didNotConsent'
      }
    },
    'wlus_diagnoseTimeline',
    'wlus_currentApproach',
    'wlus_physicalActivityLevel',
    'wlus_dietaryPlan',
    {
      key: 'wlus_MedicalConditions',
      next: {
        switch: [
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_noneOfTheAbove':
                true
            },
            key: 'wlus_hadAGastricBypassInThePast6Months'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gastroparesis':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_triglyceridesOver600AtAnyPoint':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreaticCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreatitis': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_type1Diabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_hypoglycemia': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_insulinDependentDiabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_thyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfThyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfMultipleEndocrineNeoplasiaMEN2Syndrome':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_anorexiaOrBulimia':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_currentSymptomaticGallstones':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gallbladderRemoved':
                true
            },
            key: 'wlus_consentGallbladder'
          }
        ],
        els: 'wlus_tellUsMoreAboutAboutYourMedicalConditions'
      }
    },
    {
      key: 'wlus_consentGallbladder',
      next: {
        condition: {
          'wlus_consentGallbladder.wlus_consentGallbladder_consent': true
        },
        key: 'wlus_tellUsMoreAboutAboutYourMedicalConditions',
        els: 'wlus_ineligible'
      }
    },
    'wlus_tellUsMoreAboutAboutYourMedicalConditions',
    {
      key: 'wlus_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlus_hadAGastricBypassInThePast6Months.wlus_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_allergicToAnyOfTheFollowing'
      }
    },
    {
      key: 'wlus_allergicToAnyOfTheFollowing',
      next: {
        condition: {
          'wlus_allergicToAnyOfTheFollowing.wlus_allergicToAnyOfTheFollowing_noneOfTheAbove':
            true
        },
        key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
      next: {
        condition: {
          'wlus_doYouTakeAnyOfTheFollowingMedications.wlus_doYouTakeAnyOfTheFollowingMedications_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications'
      }
    },
    {
      key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications',
      next: {
        switch: [
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_semiglutide':
                true
            },
            key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
          },
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_tirzepatide':
                true
            },
            key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
          }
        ],

        els: 'wlus_medicationSensitivities'
      }
    },

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    /////// NEW PATIENT SECTION START ///////////
    /////////////////////////////////////////////
    /////////////////////////////////////////////

    // {
    //   key: 'wlus_fearOfNeedles',
    //   next: {
    //     condition: {
    //       'wlus_fearOfNeedles.no': true
    //     },
    //     key: 'wlus_medicationSensitivities',
    //     els: 'wlus_ineligible'
    //   }
    // },

    {
      key: 'wlus_medicationSensitivities',
      next: {
        key: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    // {
    //   key: 'wlus_offerAlternative',
    //   next: {
    //     condition: {
    //       'wlus_offerAlternative.alternativeDosing': true
    //     },
    //     key: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    //     els: 'wlus_ineligible'
    //   }
    // },
    /////////////////////////////////////////////
    /////////////////////////////////////////////
    ////////// NEW PATIENT SECTION END //////////
    /////////////////////////////////////////////
    /////////////////////////////////////////////

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    /// START “PATIENTS ALREADY ON TREATMENT” ///
    /////////////////////////////////////////////
    /////////////////////////////////////////////

    'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    'wlus_sideEffects',
    // TODO: search "IncludeWhenAdditivesAdded" // Add when Additives added
    // 'wlus_offerWithAdditives',
    {
      key: 'wlus_MedicationResults',
      next: {
        switch: [
          {
            condition: {
              'wlus_MedicationResults.notLosing_noSideEffects': true
            },
            key: 'wlus_sharedDecisionMakingFast'
          },
          {
            condition: {
              'wlus_MedicationResults.notLosing_andSideEffects': true
            },
            key: 'wlus_sharedDecisionMakingSlow'
          }
        ],
        els: 'wlus_howWouldYouLikeToContinueYourTreatment'
      }
    },
    {
      key: 'wlus_sharedDecisionMakingFast',
      next: {
        key: 'wlus_howWouldYouLikeToContinueYourTreatment'
      }
    },
    'wlus_sharedDecisionMakingSlow',
    'wlus_howWouldYouLikeToContinueYourTreatment',
    {
      key: 'wlus_doYouHaveAPictureOfYourCurrentPrescription',
      next: {
        condition: {
          'wlus_doYouHaveAPictureOfYourCurrentPrescription.wlus_doYouHaveAPictureOfYourCurrentPrescription_yes':
            true
        },
        key: 'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
        els: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    /// END “PATIENTS ALREADY ON TREATMENT” ///
    /////////////////////////////////////////////
    /////////////////////////////////////////////
    'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlus_individualizedConsent',
      next: {
        condition: {
          'wlus_individualizedConsent.consent': true
        },
        key: 'wlus_consentTruthfulness',
        els: 'wlus_didNotConsent'
      }
    },

    {
      key: 'wlus_consentTruthfulness',
      next: {
        condition: {
          'wlus_consentTruthfulness.wlus_consentTruthfulness_consent': true
        },
        key: 'wlus_consentGLP1GIP',
        els: 'wlus_didNotConsent'
      }
    },
    {
      key: 'wlus_consentGLP1GIP',
      next: {
        condition: {
          'wlus_consentGLP1GIP.wlus_consentGLP1GIP_non_consent': true
        },

        key: 'wlus_didNotConsent',
        els: 'wlus_complete'
      }
    },
    'wlus_ineligible',
    'wlus_didNotConsent',
    'wlus_complete'
  ]
};
